export default __webpack_public_path__ + "static/media/story6.24a24c82.jpg";